import { createNamespace } from './helper';

export const XSD_NAMESPACE = 'http://www.w3.org/2001/XMLSchema#';
export const RDF_NAMESPACE = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#';
export const RDFS_NAMESPACE = 'http://www.w3.org/2000/01/rdf-schema#';
export const R2RML_NAMESPACE = 'http://www.w3.org/ns/r2rml#';
export const OWL_NAMESPACE = 'https://www.w3.org/2002/07/owl#';
export const SHACL_NAMESPACE = 'http://www.w3.org/ns/shacl#';

export const RDF = createNamespace(RDF_NAMESPACE, [ 'Property', 'type', 'datatype', 'JSON', 'first', 'rest', 'nil' ]);

export const RDFS = createNamespace(RDFS_NAMESPACE, [ 'subClassOf', 'label', 'range', 'domain' ]);

export const R2RML = createNamespace(R2RML_NAMESPACE, [ 'TriplesMap' ]);

export const XSD = createNamespace(XSD_NAMESPACE, [
  'boolean',
  'integer',
  'double',
  'decimal',
  'string',
  'float',
  'positiveInteger',
  'negativeInteger',
  'int',
  'date',
  'time',
  'dateTime',
  'label'
]);

export const OWL = createNamespace(OWL_NAMESPACE, [
  'Restriction',
  'onProperty',
  'allValuesFrom',
  'Class',
  'intersectionOf',
  'someValuesFrom',
  'ObjectProperty'
]);

export const SHACL = createNamespace(SHACL_NAMESPACE, [
  'NodeShape',
  'PropertyShape',
  'Literal',
  'IRI',
  'BlankNode',
  'BlankNodeOrIRI',
  'BlankNodeOrLiteral',
  'IRIOrLiteral',
  'property',
  'path',
  'name',
  'description',
  'minCount',
  'maxCount',
  'targetNode',
  'targetClass',
  'targetSubjectsOf',
  'targetObjectOf',
  'severity',
  'message',
  'deactivated',
  'and',
  'or',
  'class',
  'closed',
  'ignoredProperties',
  'datatype',
  'disjoint',
  'equals',
  'in',
  'languageIn',
  'lessThan',
  'lessThanOrEquals',
  'maxCount',
  'maxExclusive',
  'maxInclusive',
  'maxLength',
  'minCount',
  'minExclusive',
  'minInclusive',
  'minLength',
  'nodeKind',
  'pattern',
  'flags',
  'qualifiedMaxCount',
  'qualifiedMinCount',
  'qualifiedValueShape',
  'qualifiedValueShapesDisjoint',
  'uniqueLang',
  'xone',
  'inversePath',
  'zeroOrMorePath',
  'oneOrMorePath',
  'zeroOrOnePath',
  'alternativePath',
  'node'
]);
